import { render, staticRenderFns } from "./TravelServiceOrderItemCarChip.vue?vue&type=template&id=e2508f44&scoped=true&"
import script from "./TravelServiceOrderItemCarChip.vue?vue&type=script&lang=js&"
export * from "./TravelServiceOrderItemCarChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2508f44",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2508f44')) {
      api.createRecord('e2508f44', component.options)
    } else {
      api.reload('e2508f44', component.options)
    }
    module.hot.accept("./TravelServiceOrderItemCarChip.vue?vue&type=template&id=e2508f44&scoped=true&", function () {
      api.rerender('e2508f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Chips/TravelServiceOrderItemCarChip.vue"
export default component.exports